import { errorReceived } from '../../utils/data';
import MyForm from '../../utils/myForm';

function MinimalSearch() {

    return(
        <>
        {errorReceived.length > 0 && (
            <div className="alert alert-danger" role="alert">
                {errorReceived.map((err, index) => (
                    <span key={index}>{err}</span>
                ))}
            </div>
        )}
        <MyForm />
        </>
    )
}

export default MinimalSearch;